import styled, { css } from 'styled-components'

import { MEDIA_QUERY } from '../../../styles'
import { fieldWidth } from '../constants'
import { activeInputStyles, baseInputStyles, disabledStyles, responsiveStyles } from '../input.styled'
import { TextField } from '../text-field'
import { FieldWidthType } from '../types'
import ArrowIco from './../../../assets/arrow.svg'
import { SelectBoxProps } from './SelectBox'
import { SelectValueType } from './types'


export const Wrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  border-radius: 5px;
  display: inline-block;
  width: 100%;
`

export const Container = styled('div').withConfig({
  shouldForwardProp: (prop) => !['responsive'].includes(prop)
})<{ $width?: FieldWidthType | undefined; responsive?: boolean }>`
  text-align: left;
  width: ${({ $width }) => ($width ? fieldWidth[$width] : '100%')};
  ${responsiveStyles}
`

export const Caret = styled('div').withConfig({
  shouldForwardProp: (prop) => !['itemsVisible', 'disabled'].includes(prop)
})<{ itemsVisible: boolean; disabled: boolean }>`
  position: absolute;
  display: inline-block;
  -webkit-transition: 0.25s;
  transition: 0.25s;
  top: 14px;
  right: 15px;
  bottom: 0;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: url(${ArrowIco}) no-repeat center center;
  ${({ itemsVisible }) =>
    itemsVisible &&
    css`
      transform: rotate(180deg);
    `}
`

export const Input = styled(TextField)<{ $searchEnabled: SelectBoxProps<SelectValueType, unknown>['searchEnabled'] }>`
  input {
    font-size: 14px;
    padding-right: 35px;
    color: ${({ theme }) => theme.colors.font.dark};
    cursor: ${({ $searchEnabled, disabled }) => {
      if (disabled) {
        return 'not-allowed !important'
      }
      return $searchEnabled ? 'text' : 'pointer'
    }};
  }
`

export const CustomValueLabel = styled.div<{
  $valueWidth?: FieldWidthType
  disabled: boolean
  $isOpen: boolean
  $responsive?: boolean
}>`
  width: ${({ $valueWidth }) => ($valueWidth ? fieldWidth[$valueWidth] : '100%')};
  min-width: 100px;
  ${baseInputStyles};
  padding: 0 30px 0 10px;
  height: 44px;
  cursor: pointer;
  ${({ disabled }) => disabled && disabledStyles}
  font-size: 14px;
  color: ${({ theme }) => theme.colors.font.dark};
  background: ${({ theme }) => theme.colors.background.white};
  ${({ $isOpen }) => $isOpen && activeInputStyles} @media ${MEDIA_QUERY.MOBILE} {
    margin: auto;
    ${({ $responsive }) =>
      $responsive &&
      css`
        width: 100%;
      `}
  }
`

export const Items = styled.div<{ $itemsVisible: boolean }>`
  position: absolute;
  box-sizing: border-box;
  padding-right: 4px;
  z-index: 1000;
  width: calc(100%);
  border: 1px solid ${({ theme, $itemsVisible }) => ($itemsVisible ? theme.colors.input.border : 'transparent')};
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.input.white};
  left: 0;
  margin-top: 0;
  top: 47px;
`

export const ItemsInner = styled.div<{ $itemsHeight: SelectBoxProps<SelectValueType, unknown>['itemsHeight'] }>`
  position: relative;
  padding: 4px !important;
  width: 100%;
  max-height: ${({ $itemsHeight }) => ($itemsHeight === 'auto' ? $itemsHeight : $itemsHeight + 'px')};
  overflow-y: auto;
  margin: 0;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.common.regular.brightBlue};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.input.white};
  }
`

export const OptionsList = styled.ul`
  list-style: none;
`

export const GroupLabel = styled.label`
  text-align: left;
  font-size: 14px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.grey};
  padding: 3px 7px;
`
